<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'xl'" :btn_cancel="true" :btn_ok="true" 
    :booTitile="true" :fullScreen="false">
        
        <div style="height: 100%;">
            <div class="py-3">
                <span class="background">
                    <section id="myTabContentHijoHC" class="col-md-12 gallery">
                        <article>
                            <div id="div3-content" class="row p-2">
                                <div class="col-xl-12 col-lg-12">
                                    <div class="panel-border my-1">
                                        <div class="row my-1 px-3">
                                            <div class="col-md-12" id="content-timelinetable">
                                                <table class="mb-2">
                                                    <caption class="div-text py-0 my-0"></caption>
                                                    <thead class="">
                                                    <tr>
                                                        <th colspan="7" scope="col" class="text-xs">Seleccione Medicamentos:</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody class="div-text">
                                                        <tr class="px-1">
                                                            <td colspan="2" class="w-25 z-index-select">
                                                            <input type="text" v-model="receta" placeholder="Molecula"
                                                                class="form-control form-control-input form-control-sm" :disabled="showHistory"
                                                                @keyup.enter="mtdopenmodal"/>
                                                            </td>
                                                            <td v-if="recipe_unit.presentation != '-'">
                                                            <input type="text" v-model="recipe_unit.presentation"
                                                                class="form-control form-control-input form-control-sm" placeholder="Presentación"
                                                                disabled />
                                                            </td>
                                                            <td v-if="!type">
                                                            <input type="text" v-model="recipe_unit.dosis"
                                                                class="form-control form-control-input form-control-sm" placeholder="Concentración"
                                                                disabled />
                                                            </td>
                                                            <td v-if="!type || type_name == 3">
                                                                <select class="form-control form-control-input form-control-sm" 
                                                                    aria-label="Default select example" v-model="recipe_unit.via" :disabled="showHistory">
                                                                    <option selected value="" >Seleccione...</option>
                                                                    <option value="VO">VO</option>
                                                                    <option value="EV">EV</option>
                                                                </select>
                                                            </td>
                                                            <td v-if="!type  && !mix_state">
                                                            <input v-on:keypress="isNumber($event)" type="text" v-model="recipe_unit.frequency"
                                                                placeholder="Frecuencia (Horas)" class="form-control form-control-input form-control-sm"
                                                                :disabled="showHistory"/>
                                                            </td>
                                                            <td v-if="!type && !mix_state">
                                                            <input v-on:keypress="isNumber($event)" type="text" v-model="recipe_unit.duration"
                                                                class="form-control form-control-input form-control-sm" placeholder="Duración (Días)"
                                                                :disabled="showHistory"/>
                                                            </td>
                                                            <td v-if="type || mix_state">
                                                            <input v-on:keypress="isNumber($event)" type="text" v-model="recipe_unit.total"
                                                                placeholder="Total" class="form-control form-control-input form-control-sm"
                                                                :disabled="showHistory"/>
                                                            </td>
                                                            <td v-if="!type" style="width: 50px;">
                                                            <button v-if="!type && !mix_state" type="button" :disabled="validationInputrecipe || showHistory"
                                                                @click="mtdaddrecipe()" class=" btn btn-success btn-sm px-1 py-0"> <i
                                                                class="fas fa-plus text-white"></i> </button>
                                                                <button v-if="type || mix_state" type="button" @click="mtdaddrecipe()" class=" btn btn-success btn-sm px-1 py-0"> <i class="fas fa-plus text-white"></i> </button>
                                                            </td>
                                                            <td v-else style=" width: 50px;" class="d-flex">
                                                            <button :disabled="validationtotal" type="button" @click="mtdaddrecipe()"
                                                                class=" btn btn-success btn-sm px-1 py-0"> <i class="fas fa-plus text-white"></i>
                                                            </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <table class="w-100 table table-bordered">
                                                    <caption class="div-text"></caption>
                                                    <thead class="div-text div-title text-center align">
                                                    <tr>
                                                        <th scope="col">Rp.</th>
                                                        <th>Medicamentos</th>
                                                        <th>Presentacion</th>
                                                        <th>Concentración</th>
                                                        <th>Via</th>
                                                        <th>Dosis de Mezcla</th>
                                                        <th>Frecuencia (Horas)</th>
                                                        <th>Duracion (Días)</th>
                                                        <th >Total</th>
                                                        <th>Tipo</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody class="div-text " v-if="recipe.length > 0">
                                                    <tr v-for="(recipeunit, index) in recipe" :key="index" class="px-1 text-center">
                                                        <td>
                                                        <span>{{ index + 1 }}</span>
                                                        </td>
                                                        <td>
                                                        <span>{{ recipeunit.molecule }}</span>
                                                        </td>
                                                        <td>
                                                        <span>{{ recipeunit.presentation }}</span>
                                                        </td>
                                                        <td>
                                                        <span>{{  recipeunit.dosis  }}</span>
                                                        </td>
                                                        <td>
                                                        <span>{{ recipeunit.via }}</span>
                                                        </td>
                                                        <td>
                                                        <span>{{ recipeunit.group == 0 ? (recipeunit.type == 1 ? 'SIN DOSIS': '-') : (recipeunit.quantity + ' ' + (recipeunit.medida == 1 ? 'CC' : (recipeunit.medida ==2 ? 'ML': 'GOTAS') ) + '/' + (recipeunit.tiempo == 1 ? 'H': 'MIN'))}}</span>
                                                        </td>
                                                        <td>
                                                        <span>{{ recipeunit.frequency }}</span>
                                                        </td>
                                                        <td>
                                                        <span>{{ recipeunit.duration }}</span>
                                                        </td>
                                                        <td>
                                                            <span>{{ recipeunit.total }}</span>
                                                        </td>
                                                        <td>
                                                        <span>{{ recipeunit.type == 2 ? 'INSUMO' : recipeunit.type == 3 ? 'SOLUCION' :
                                                            'MEDICAMENTO' }}</span>
                                                        </td>
                                                        <td>
                                                        <button type="button" @click="mtddelete(index, 'mtddeleterecipe')"
                                                            class=" btn btn-danger btn-sm px-1 py-0 " :disabled="showHistory"> <i
                                                            class="fas fa-trash-alt text-white"></i> </button>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                    <tbody class=" text-center" v-else>
                                                    <tr>
                                                        <td colspan="11" class=" text-center">
                                                            <span class="fw-bold text-xxs"> No hay resultados</span>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel-border my-1">
                                        <div class="row px-3">
                                            <div class="col-md-12 my-1">
                                            <div id="div-recomendacion" class="form-group row align-left">
                                                <label for="recomendacion" class="col-sm-3 color-main fw-bold"> Indicaciones y/o
                                                Recomendaciones
                                                <span class="info-icon color-main mx-2">
                                                    <i class="fas fa-info-circle fs-6"></i>
                                                </span>
                                                </label>
                                                <div class="col-xl-9 col-sm-12">
                                                <textarea id="recomendacion" class="form-control form-control-sm" rows="3"
                                                    v-model="clinica_history.recomendations" style="resize: none;" :disabled="showHistory"/>
                                                </div>
                                            </div>
                                            </div>
                                            <div class="col-md-1"></div>
                                        </div>
                                    </div>
                                    <div class="panel-border my-1">
                                        <div class="row px-3">
                                            <div class="col-md-12 my-1">
                                            <div id="div-recomendacion" class="form-group row align-left">
                                                <label for="recomendacion" class="col-sm-3 color-main fw-bold">Dieta
                                                <span class="info-icon color-main mx-2">
                                                    <i class="fas fa-info-circle fs-6"></i>
                                                </span>
                                                </label>
                                                <div class="col-xl-9 col-sm-12">
                                                <textarea id="recomendacion" class="form-control form-control-sm" rows="3"
                                                    v-model="clinica_history.dieta" style="resize: none;" :disabled="showHistory"/>
                                                </div>
                                            </div>
                                            </div>
                                            <div class="col-md-1"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </section>
                </span>
            </div>
        </div>

        <template #footer>
            <button class="btn btn-success btn-sm" :disabled="showHistory || recipe.length <= 0"  @click="registerRecipe()">
                <i class="fas fa-solid fa-save"></i> Guardar
            </button>
        </template>
        <Medicine :posmedicine="posmedicine" :receta="receta" :title="modalmedicine.title"
      :boo_modal="modalmedicine.modal_form" @mtdclosemodalmedicine="mtdclosemodalmedicine" @addreceta="addreceta" />
      <SweetAlert :swal="swal" ref="SweetAlert" @mtddeleterecipe="mtddeleterecipe" />
    </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import {mapActions} from "vuex";
import Medicine from '@/components/Asistencial/Hospitalizacion/modals/cModalMedicine.vue';
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
export default {
    name: "c-modal-recipeAlta",
    components: {
        CModal,
        SweetAlert,
        Medicine
    },
    data() {
        return {
            swal: null,
            clinica_history: {
                id: null,
                user_id: null,
                recipe: [],
                recomendations: '',
                patient_id: null,
                model_id: null,
                medical_act_id: null,
                dieta: '',
                insuline: '',
                type: ''
            },
            clinica_history_plantilla: {
                id: null,
                user_id: null,
                recipe: [],
                recomendations: '',
                patient_id: null,
                model_id: null,
                medical_act_id: null,
                dieta: '',
                insuline: '',
                type: ''
            },
            recipe_unit: {
                order: null,
                product_id: null,
                molecule: '',
                presentation: '',
                dosis: '',
                via: '',
                frequency: '',
                duration: '',
                type: null,
                total: null,
                quantity: null,
                group: 0,
                prn: false,
                medida: null,
                tiempo: null
            },
            recipe: [],
            modalmedicine: {
                title: "",
                modal_form: false,
            },
            posmedicine: null,
            receta: '',
            type: false,
            group_state: false,
            noInsumos: [],
            insuline_state: false,
            type_name: 0,
            mix_state:false
        };
    },
    created() {
        //this.mtdfilldata();
    },
    watch: {
        showHistory: {
            handler: function (newValue) {
                //this.rpHistoryTransaccion();
            },
            deep: true,
            immediate: true,
        },
        Clinicahistory: {
            handler(newVal) {
                if (Object.keys(newVal).length !== 0) {
                    this.mtdfilldata();
                }
            },
            deep: true,
            immediate: true
        }
    },
    props: {
        title: String,
        boo_modal: Boolean,
        Clinicahistory: {
            type: Object,
            default: () => ({}),
        },
        showHistory: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        validationInputrecipe: function () {
            let value = true
            if (this.receta && this.recipe_unit.frequency && this.recipe_unit.via && this.recipe_unit.duration) {
                value = false
            }
            return value
        },

        validationtotal: function () {
            let value = true
            if (this.recipe_unit.total) {
                value = false
            }
            return value
        },

  },
    methods: {
        ...mapActions(['get', 'post']),

        mtdaddrecipe: function () {
            this.recipe_unit.duration =  this.recipe_unit.total ? '-': this.recipe_unit.duration 
            this.recipe_unit.frequency =  this.recipe_unit.total ? '-': this.recipe_unit.frequency
            this.recipe_unit.total = this.recipe_unit.total ? this.recipe_unit.total : ''
            const exists = this.recipe.some(item => item.molecule + ' ' + item.presentation + ' ' + item.dosis === this.recipe_unit.molecule + ' ' + this.recipe_unit.presentation + ' ' + this.recipe_unit.dosis);
            if (exists) {
                this.$refs.SweetAlert.showWarning("Medicamento ya agregado");
            } else {
                this.recipe.push(this.recipe_unit);
            }
            this.type = false
            this.receta = null
            this.recipe_unit = {
                order: null,
                product_id: null,
                molecule: '',
                presentation: '',
                dosis: '',
                via: '',
                frequency: '',
                duration: 1,
                type: null,
                total: null,
                quantity: null,
                group: 0,
                prn: false,
                medida: null,
                tiempo: null
            }
            this.noInsumos = []
            this.insuline_state = false
            this.recipe.forEach(item => {
                if (item.type == 1 && item.duration =='-') {
                this.noInsumos.push(item)
                }
                if (item.type == 1 && item.molecule.toLowerCase().includes('insulina')) {
                this.insuline_state = true
                }
            })
            this.mtdconcatenar()
            this.mix_state =  false
        },

        mtddelete: function (index, msg) {
            this.$refs.SweetAlert.showDelete(index, msg);
        },

        mtddeleterecipe: function (index) {
            let num = this.recipe[index].group
            if (this.recipe[index].group != 0) {
                for (let j = this.recipe.length - 1; j >= 0; j--) {
                if (this.recipe[j].group == num) {
                    this.recipe.splice(j, 1);
                }
                }
            } else {
                this.recipe.splice(index, 1);
            }
            this.insuline_state = false
            for (let i = 0; i < this.recipe.length; i++) {
                this.recipe[i].order = i + 1;
                if (this.recipe[i].type == 1 && this.recipe[i].molecule.toLowerCase().includes('insulina')) {
                this.insuline_state = true
                }
            }
            if (!this.insuline_state) {
                this.clinica_history.insuline = null
            }
            this.mtdconcatenar()
        },

        mtdconcatenar:function(){
            this.clinica_history.recomendations = ''
            this.recipe.forEach(item2 =>{
                if(item2.type == 1){ 
                    let msg = '-' + item2.molecule + ' ' + item2.presentation + ' ' + item2.dosis + ' ' + item2.via;
                    if (item2.frequency !='-' && item2.duration !='-') {
                        msg += ' cada ' + item2.frequency + 'H por ' + item2.duration + 'D';
                    }
                    if (this.clinica_history.recomendations) {
                        this.clinica_history.recomendations += ` \n${msg}`;
                    } else {
                        this.clinica_history.recomendations = `${msg}`;
                    }
                }
            })
        },

        mtdfilldata: function () {
            if (Object.keys(this.Clinicahistory).length !== 0) {
                this.clinica_history.patient_id = this.Clinicahistory.patient_id;
                this.clinica_history.id = this.Clinicahistory.id;
                this.recipe = JSON.parse(this.Clinicahistory.recipe);
                this.clinica_history.recomendations = this.Clinicahistory.recomendations;
                this.clinica_history.dieta = this.Clinicahistory.dieta;
                this.clinica_history.medical_act_id = this.Clinicahistory.medical_act_id;
                this.clinica_history.insuline = this.Clinicahistory.insulin;
                this.clinica_history.user_id = this.$store.getters.get__user.id;
                this.clinica_history.type = this.Clinicahistory.type;

                this.clinica_history_plantilla.patient_id = this.Clinicahistory.patient_id;
                this.clinica_history_plantilla.id = this.Clinicahistory.id;
                this.clinica_history_plantilla.recipe = JSON.parse(this.Clinicahistory.recipe);
                this.clinica_history_plantilla.recomendations = this.Clinicahistory.recomendations;
                this.clinica_history_plantilla.dieta = this.Clinicahistory.dieta;
                this.clinica_history_plantilla.medical_act_id = this.Clinicahistory.medical_act_id;
                this.clinica_history_plantilla.insuline = this.Clinicahistory.insulin;
                this.clinica_history_plantilla.user_id = this.$store.getters.get__user.id;
                this.clinica_history_plantilla.type = this.Clinicahistory.type;

                this.insuline_state = false
                this.recipe.forEach(item => {
                if (item.type == 1 && item.molecule.toLowerCase().includes('insulina')) {
                    this.insuline_state = true
                }
                })
            }
        },

        addreceta: function (payload) {
            this.type = (payload.type == 2 || payload.type == 3) ? true : false
            this.type_name = payload.type
            this.receta = payload.molecule
            this.recipe_unit.order = this.recipe.length + 1;
            this.recipe_unit.molecule = payload.molecule ? payload.molecule : '-';
            this.recipe_unit.type = payload.type
            this.posmedicine = null;
            this.modalmedicine = {
                title: "",
                modal_form: false,
            }
            if (this.type) {
                this.recipe_unit.via =  '-'
                this.recipe_unit.frequency = '-'
                this.recipe_unit.duration = '-'
                this.recipe_unit.dosis = payload.dosis ? payload.dosis : '-';
                this.recipe_unit.presentation = payload.presentation ? payload.presentation : payload.commercial;
            } else {
                this.recipe_unit.dosis = payload.dosis;
                // this.recipe_unit.quantity = payload.dosis;
                this.recipe_unit.presentation = payload.presentation;
                this.recipe_unit.duration = 1
            }
        },

        mtdopenmodal: function () {
            if (this.receta) {
                this.posmedicine = 1;
                this.modalmedicine = {
                title: "Lista de Medicamentos",
                modal_form: true,
                }
            } else {
                this.$refs.SweetAlert.showWarning('Digite Molecula');
            }
        },

        mtdclosemodalmedicine: function () {
            this.posmedicine = null;
            this.modalmedicine = {
                title: "",
                modal_form: false,
            }
            this.receta = '',
                this.recipe_unit = {
                order: null,
                product_id: null,
                molecule: '',
                presentation: '',
                dosis: '',
                via: '',
                frequency: '',
                duration: '',
                quantity: null,
                group: 0,
                prn: false,
                medida: null,
                tiempo: null
            }
        },

        isNumber: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        mtdPrnGroup: function (payload) {
            if (payload.group != 0) {
                this.recipe.forEach(item => {
                    if (item.group == payload.group) {
                        item.prn = !item.prn
                    }
                })
            }
        },

        /* TRAER LAS RP DEL DESTINO ANTERIOR*/
        rpHistoryTransaccion: function () {
        if (!this.showHistory && this.Clinicahistory.medical_act_id) {
            this.get({
            url: this.$store.getters.get__url + "/Hospitalization/rpHistoryTransaccion/" + this.Clinicahistory.medical_act_id,
            token: this.$store.getters.get__token,
            })
            .then((response) => {
                if (response.data) {
                let receta = response.data.recipe;
                this.recipe = JSON.parse(receta);
                }
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        }
        },

        mtdClose() {
            this.clear();
            this.$emit("closeModalRecipe");
        },

        registerRecipe() {
            this.$refs.SweetAlert.showConfirmSimple2("¿Estás seguro de Registrar esta RECETA DE ALTA?", "No podrá volver a Editar", "warning", "Confirmar")
            .then((result) => {
                if (result.value) {
                    this.mtdRegisterRecipe();
                }
            });
        },

        mtdRegisterRecipe() {
            this.post({
                url: this.$store.getters.get__url + "/Hospitalization/storeRecipeDischarge",
                token: this.$store.getters.get__token,
                params: {
                    recipe: this.recipe,
                    clinica_history: this.clinica_history
                },
            }).then((response) => {
                if (response.statusCode === 200) {
                    this.$refs.SweetAlert.showSuccess("Recetas de Alta Registradas Correctamente");
                    this.mtdClose();
                }else{
                    this.$refs.SweetAlert.showError("Error");
                }
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        clear() {
            this.recipe_unit = {
                order: null,
                product_id: null,
                molecule: '',
                presentation: '',
                dosis: '',
                via: '',
                frequency: '',
                duration: '',
                type: null,
                total: null,
                quantity: null,
                group: 0,
                prn: false,
                medida: null,
                tiempo: null
            },
            this.clinica_history = {
                id: null,
                user_id: null,
                recipe: [],
                recomendations: '',
                patient_id: null,
                model_id: null,
                medical_act_id: null,
                dieta: '',
                insuline: ''
            },
            this.clinica_history_plantilla = {
                id: null,
                user_id: null,
                recipe: [],
                recomendations: '',
                patient_id: null,
                model_id: null,
                medical_act_id: null,
                dieta: '',
                insuline: ''
            },
            this.recipe = []
        }
    }
};
</script>
